<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001538') }}</span>
				</div>
			</div>
		</div>
		<sf-data-table
			ref="dataTable"
			:paging="false"
			:columns="columns"
			:rows="rows"
			:stripe="false"
			:excel="isButton_(scrId, 'EX')"
			selection
			style="height: 380px"
		>
			<template v-slot:actionsLeft> </template>
			<template v-slot:actionsRight>
				<sf-button v-if="isButton_(scrId, 'EU')" line icon="excel" :onClick="downExcelTemp">
					{{ getMessage_('QWCC001799') }}
				</sf-button>
				<sf-button v-if="isButton_(scrId, 'EU')" line icon="excel" :onClick="openModal">
					{{ getMessage_('QWCC000927') }}
				</sf-button>
			</template>
		</sf-data-table>
	</div>
</template>

<script>
import * as yup from 'yup';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../../store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	data() {
		return {
			addRowData: []
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.pmcIdList;
		},
		columns() {
			return [
				{
					label: this.getMessage_('QWCC001538'), //PMCID
					prop: 'pmcId',
					align: 'center',
					width: '200px',
					type: 'input'
				},
				{
					label: this.getMessage_('QWCC000976'), //R/O 번호
					prop: 'roNo',
					align: 'center',
					width: '180px',
					type: 'input'
				},
				{
					label: this.getMessage_('QWCC000979'), //신청일자
					prop: 'aplcDd',
					width: '120px',
					align: 'center',
					type: 'input'
				},
				{
					label: this.getMessage_('MWCC000980'), //확정일자
					prop: 'dcsnDd',
					width: '120px',
					align: 'center',
					type: 'input'
				},
				{
					label: '',
					minWidth: '120px',
					align: 'center',
					sortable: false
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		openModal() {
			const cmpnNo = this.cmpnMstPopup.cmpnNo;

			if (cmpnNo == '') {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000009'),
					message: this.getMessage_('QWCC001142')
				}); //캠페인을 먼저 등록해주십시오
			} else {
				// 엑셀업로드팝업 호출
				const param = {
					title: this.getMessage_('QWCC001148'), //타이틀바 값 pmcId 엑셀 업로드
					apiGubun: 'CMPN_MST', //업무구분값
					flag: 'I', //INSERT는 i Update U로 만듬
					param1: this.cmpnMstPopup.cmpnNo //캠페인 번호
				};
				this.$emit('PopupOpen', param); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
			}
		},
		resetTable() {
			this.$emit('Refresh');
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		resetSelection() {
			//체크박스 해제
			let checkedCount = document.getElementsByClassName('is-checked').length;
			for (let i = 0; i < checkedCount; i++) {
				document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
			}

			this.$emit('Refresh');
		},
		downExcelTemp() {
			let params = {
				apiGubun: 'CMPN_MST'
			};

			this.excelTempDown_(params)
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message || this.getMessage_('QWCC001920') //권한이 없거나 다운로드 할 수 없습니다.
					});
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>
